import { createSlice } from "@reduxjs/toolkit";

export const binStatus = createSlice({
  name: "binStatus",
  initialState: {
    binCounts: {},
    treeRemovalCounts: {},
    junkRemovalCounts: {},
    companyCounts: {},
    leadCounts: {},
    salesLeadCounts: {},
    financingCounts: {},
    builderOfferCounts: {},
    totalUnreadCount: 0,
    globalNotificationCount: 0,
  },
  reducers: {
    setBinCounts: (state, action) => {
      state.binCounts = action.payload;
    },
    setTreeRemovalCounts: (state, action) => {
      state.treeRemovalCounts = action.payload;
    },
    setJunkRemovalCounts: (state, action) => {
      state.junkRemovalCounts = action.payload;
    },
    setCompanyCounts: (state, action) => {
      state.companyCounts = action.payload;
    },
    setLeadCounts: (state, action) => {
      state.leadCounts = action.payload;
    },
    setSalesLeadCounts: (state, action) => {
      state.salesLeadCounts = action.payload;
    },
    setFinancingCounts: (state, action) => {
      state.financingCounts = action.payload;
    },
    setBuilderOfferCounts: (state, action) => {
      state.builderOfferCounts = action.payload;
    },
    setTotalUnreadCount: (state, action) => {
      state.totalUnreadCount = action.payload;
    },
    decrementUnreadCount: (state, action) => {
      const amount = action.payload || 0;
      state.totalUnreadCount = Math.max(0, state.totalUnreadCount - amount);
    },
    incrementUnreadCount: (state) => {
      state.totalUnreadCount += 1;
    },
    setActiveChatId: (state, action) => {
      state.activeChatId = action.payload;
    },
    setGlobalNotificationCount: (state, action) => {
      state.globalNotificationCount = action.payload;
    },
  },
});

export const {
  setBinCounts,
  setTreeRemovalCounts,
  setJunkRemovalCounts,
  setCompanyCounts,
  setLeadCounts,
  setSalesLeadCounts,
  setFinancingCounts,
  setBuilderOfferCounts,
  setTotalUnreadCount,
  decrementUnreadCount,
  incrementUnreadCount,
  binCounts,
  setActiveChatId,
  setGlobalNotificationCount,
} = binStatus.actions;

export default binStatus.reducer;
